module.exports = __webpack_public_path__ + "res/31-img_card_bg.16af11d20656b4d0a2a4b81c8436b7a3.png";